import { DateTime } from 'luxon';
import { Card } from '@Components/Card/index';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import { Separator } from '@art-of-hospitality-solutions-llc/ui-kit/components/separator';
import { useFishDetails } from '../FishDetailsContext';
import { EMPLOYEE_VENUE_MAP } from '../employeeVenues';

export default function EmploymentPanel() {
  const { employeeProfile } = useFishDetails();

  return (
    <>
                <Card className="p-8">
                  <div className="w-full">
                    <Separator className="bg-[#caab6a]" />
                    <Heading level={'h5'}>Employment Details</Heading>
                    <Separator className="bg-[#caab6a]" />
                  </div>

                  <div className="flex justify-between">
                    <div className="flex flex-col">
                      <div className="font-bold">Department:</div>
                      <div className="pb-4">
                        {employeeProfile?.employee_department || 'N/A'}
                      </div>

                      <div className="font-bold">Position:</div>
                      <div className="pb-4">
                        {employeeProfile?.employee_position || 'N/A'}
                      </div>

                      <div className="font-bold">Start Date:</div>
                      <div className="pb-4">
                        {employeeProfile?.employee_start_date
                          ? DateTime.fromISO(
                              employeeProfile?.employee_start_date,
                            )
                              .toLocal()
                              .toFormat('MM/dd/yyyy')
                          : 'N/A'}
                      </div>

                      <div className="font-bold">Status:</div>
                      <div className="pb-4">
                        {employeeProfile?.employee_status === 'TERMINATED'
                          ? 'Terminated'
                          : 'Active'}
                      </div>
                    </div>

                    <div className="flex flex-col">
                      <div className="font-bold">Venue:</div>
                      <p>{employeeProfile?.employee_venue || 'N/A'}</p>
                      <div>
                        <img
                          src={
                            EMPLOYEE_VENUE_MAP.find(
                              (v) =>
                                v.label === employeeProfile?.employee_venue,
                            )?.image ?? '/placeholder_landmark_logo.jpg'
                          }
                          alt={
                            EMPLOYEE_VENUE_MAP.find(
                              (v) =>
                                v.label === employeeProfile?.employee_venue,
                            )?.label ?? 'placeholder logo'
                          }
                          className="max-h-37.5 max-w-37.5 object-cover"
                        />
                      </div>
                    </div>
                  </div>
                </Card>
    </>
  );
}
